import styled from 'styled-components';
import { Link } from 'react-router-dom';

/* Menu lateral do Figma: fundo escuro da barra, item ativo em laranja. A
 * largura é a mesma do recuo do conteúdo no `ClientLayout`. */
export const SIDEBAR_WIDTH = 220;

export const SidebarContainer = styled.nav`
  position: fixed;
  z-index: 98;
  top: 64px;
  left: 0;
  width: ${SIDEBAR_WIDTH}px;
  height: calc(100vh - 64px);
  overflow-y: auto;
  padding: 16px 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  background-color: ${(props) => props.theme.color.bg.secondary};

  @media only screen and (max-width: 950px) {
    display: none;
  }

  @media print {
    display: none;
  }
`;

export const SidebarLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 9px 12px;
  border-radius: 3px;
  font-family: ${(props) => props.theme.font.body.family};
  font-size: ${(props) => props.theme.font.body.size.small};
  color: ${(props) => props.theme.color.text.inverse};
  text-decoration: none;

  svg {
    flex-shrink: 0;
    font-size: 16px;
  }

  &:hover {
    color: ${(props) => props.theme.color.text.inverse};
    background: rgba(255, 255, 255, 0.08);
  }

  &.active {
    font-weight: ${(props) => props.theme.font.body.weight.bold};
    background: ${(props) => props.theme.color.ui.primary};
  }
`;
